import React, { useEffect, useState } from "react";
import blogbg from '../../assests/blog/blog-banner.jpg'
import img1 from '../../assests/blog/Digi.png'
import img2 from '../../assests/blog/Hiring Process.jpg'
import img3 from '../../assests/blog/IT Staffing Services.jpg'
import img4 from '../../assests/blog/Limit Damages.jpg'
import img5 from '../../assests/blog/Woo-migration.jpg'
import img6 from '../../assests/blog/angu.png'
import img7 from '../../assests/blog/blog-banner.jpg'
import img8 from '../../assests/blog/blogi-staffing1.jpeg'
import img9 from '../../assests/blog/blogi-staffing2.jpeg'
import img10 from '../../assests/blog/blogi-staffing3.jpg'
import img11 from '../../assests/blog/contract-staffing.jpg'
import img12 from '../../assests/blog/mb.png'
import img13 from '../../assests/blog/images.png'
import { useNavigate } from "react-router-dom";

const categories = ["All", "Business", "Technology", "Design", "Culture", "Updates"];

const blogPosts = [
  // {
  //   title: "Top 10 Effective Ways To Reduce Time To Hire With Dynamic Staffing Services",
  //   image: img11,
  //   category: "Business",
  //   date: "Apr 24, 2024",
  //   author: "John Doe",
  //   summary: "There are a lot of things that may go wrong. That's why companies need to find the right staffing solution for their needs ...",
  //   id: "business-growth-strategies",
  //   link: '/blogDetail',
  // },
  {
    title: "Everything You Should Know About IT Staffing Services",
    image: img3,
    category: "Technology",
    date: "Apr 25, 2024",
    author: "Jane Smith",
    summary: "IT staffing services act as a bridge between employers and employees, matching qualified candidates ....",
    id: "business-growth-strategies2",
    link: '/ITStaffingServices',
  },
  {
    title: "How to limit the damages of the delayed recruitment process with help of strategic staffing solutions?",
    image: img4,
    category: "Design",
    date: "Apr 20, 2024",
    author: "Alex Lee",
    summary: "Staffing management methods originated to help companies spot and acquire the employees they need ...",
    id: "business-growth-strategies3",
    link: '/delayedRecruitment',

  },
  {
    title: "How is the hiring process taking too long and hurting your business? Why do you need a staffing solutions company?",
    image: img2,
    category: "Culture",
    date: "Apr 15, 2024",
    author: "Maria Green",
    summary: "When we hear the idea of a long time in recruitment, this sounds like ...",
    id: "business-growth-strategies4",
    link: '/staffingSolutions',

  },
  {
    title: "How Can A Staffing Solutions Company Help Your Business?",
    image: img11,
    category: "Culture",
    date: "Apr 15, 2024",
    author: "Maria Green",
    summary: "Staffing solutions come in many forms to meet the needs of specific clients, ranging ....",
    id: "business-growth-strategies5",
    link: '/helpYourBusiness',

  }, {
    title: "How Most Companies Use Global IT Staffing Solutions?",
    image: img8,
    category: "Culture",
    date: "Apr 15, 2024",
    author: "Maria Green",
    summary: "Many software companies want to outsource services for which they do not have the expertise or experience of the ....",
    id: "business-growth-strategies6",
    link: '/globalITStaffingSolutions',

  }, {
    title: "The Role Of Staffing Solutions Need For Small To Big Business Company",
    image: img10,
    category: "Culture",
    date: "Apr 15, 2024",
    author: "Maria Green",
    summary: "If you are operating a small business, you may end up doing most of the tasks on your ....",
    id: "business-growth-strategies7",
    link: '/smallToBigBusinessCompany',

  }, {
    title: "Why Staffing Solutions Are Crucial For Business Excellence?",
    image: img9,
    category: "Culture",
    date: "Apr 15, 2024",
    author: "Maria Green",
    summary: "Staffing has always been a vital support function in all critical management....",
    id: "business-growth-strategies8",
    link: '/businessExcellence',

  }, {
    title: "Internet Marketing Services",
    image: img1,
    category: "Culture",
    date: "Apr 15, 2024",
    author: "Maria Green",
    summary: "Internet marketing services USA, social media optimization, grow your business, online marketing experts, increase business sales....",
    id: "business-growth-strategies9",
    link: '/internetMarketingServices',

  }, {
    title: "Mobile App Development?",
    image: img12,
    category: "Culture",
    date: "Apr 15, 2024",
    author: "Maria Green",
    summary: "There is constant debate about Cross-platform vs. Native mobile application development. This debate has divided the tech community....",
    id: "business-growth-strategies11",
    link: '/mobileAppDevelopment',

  }, {
    title: "Why AngularJS for Web?",
    image: img6,
    category: "Culture",
    date: "Apr 15, 2024",
    author: "Maria Green",
    summary: "AngularJS іѕ bеіng adopted bу developers аll оvеr thе world fоr іtѕ ability tо рrеѕеnt data іn a vеrу attractive wау. Thе structure...",
    id: "business-growth-strategies12",
    link: '/angulerJsWebPage',

  },
  {
    title: "Why are JAVA and Dot Net in the boom again?",
    image: img5,
    category: "Culture",
    date: "Apr 15, 2024",
    author: "Maria Green",
    summary: "JAVA and Dot Net both are the most common technologies used by an enterprise for technical aspects and they’re in high demand among the...",
    id: "business-growth-strategies10",
    link: '/JAVAandDotNet',

  }, {
    title: "How to Speed Up Your WordPress Website ?",
    image: img13,
    category: "Culture",
    date: "Apr 15, 2024",
    author: "Maria Green",
    summary: "Long back, WordPress used to be a primary tool to create websites but with the advanced features, this has become....",
    id: "business-growth-strategies13",
    link: '/WordPressWebsite',

  },
];

const BlogPage = () => {
  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  const router = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState("All");
  

  const filteredPosts =
    selectedCategory === "All"
      ? blogPosts
      : blogPosts.filter((post) => post.category === selectedCategory);

  return (
    <div className=" mx-auto lg:px-24 2xl:px-28 py-10">
      {/* <div className="text-center mt-20 mb-10">
        <h1 className="lg:text-4xl text-[54px] font-bold text-gray-900">Our Blog</h1>
        <p className="text-gray-600 lg:text-[16px] text-[34px] mt-2">
          Stay updated with the latest trends, stories, and updates from our team.
        </p>
      </div> */}

      {/* Search */}
      {/* <div className="max-w-xl mx-auto mb-6">
        <input
          type="text"
          placeholder="Search blog posts..."
          className="w-full px-4 py-3 text-[34px] lg:text-[18px] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div> */}

      {/* Category Buttons */}
      <div className="flex flex-wrap justify-center gap-3 mb-8">
        {categories.map((cat) => (
          <button
            key={cat}
            onClick={() => setSelectedCategory(cat)}
            className={`px-4 py-2 rounded-full text-[34px] lg:text-sm font-medium transition ${selectedCategory === cat
                ? "bg-blue-600 text-white"
                : "bg-gray-100 text-gray-700 hover:bg-gray-200"
              }`}
          >
            {cat}
          </button>
        ))}
      </div>
      <div className="rounded-xl overflow-hidden shadow-md mb-12 bg-white">
        <img src={img11} className="w-full h-[500px]" />
        <div className="p-6 flex justify-between items-center flex-wrap gap-4">
          <div>
            <h2 className="lg:text-3xl text-[44px] font-bold text-gray-900 mb-2">Top 10 Effective Ways To Reduce Time To Hire With Dynamic Staffing Services</h2>
            <p className="text-gray-600 lg:text-[20px] text-[34px] max-w-xl">
            There are a lot of things that may go wrong. That's why companies need to find the right staffing solution for their needs ...
            </p>
          </div>
          <button className="bg-blue-600 text-[34px] lg:text-sm text-white px-5 py-2 rounded-lg hover:bg-blue-700 transition" 
          onClick={() => router('/blogDetail')}>
            Read More
          </button>
        </div>
      </div>

      {/* Blog Cards */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">

        {filteredPosts.map((post, idx) => (
          <div key={idx} className="bg-white border rounded-xl p-5 shadow-sm flex flex-col justify-between h-full">
            <div>
              <img src={post?.image} className="w-full lg:h-44 2xl:h-60 object-cover rounded-md" />
              <h2 className="2xl:text-[20px] lg:text-[16px] text-[44px] mt-4 font-bold text-center font-recoleta text-gray-900">
                {post.title}
              </h2>
              <p className="text-gray-600 text-center 2xl:text-[16px] text-[36px] font-recoleta lg:text-[13px] mt-2">
                {post.summary}
              </p>
            </div>

            <div className="mt-4 justify-self-center text-center">
              <button
                className="lg:w-[40%] 2xl:w-[30%] w-full text-white rounded-lg lg:px-4 px-10 lg:py-2 py-4 text-[34px] lg:text-sm hover:bg-blue-700   bg-blue-600  font-medium"
                onClick={() => router(`${post.link}`)}
              >
                Read More
              </button>
            </div>
          </div>
        ))}

      </div>
    </div>
  );
};

export default BlogPage;
